export const drawPerspective = (ctx, img, l, t, r, b, x, y, d, s) => {
  // Copyright: Lutz Tautenhahn, 2019, http://www.lutanho.net/
  // License: Apache License, Version 2.0
  let i, x0, y0, x1, y1, x2, y2, x3, y3, sl, st, sr, sb;
  const ep = 0.01;
  const w = r - l;
  const h = b - t;
  const xc = w / 2;
  const yc = h / 2;
  const m = [0, 0];
  const f = [0, 0];
  function LLI(r, a, b, c, d, e, f, g, h) {
    const x = (a + c + e + g) / 4;
    const y = (b + d + f + h) / 4;
    r[0] =
      x -
      ((a - c) * ((f - y) * (g - x) - (e - x) * (h - y)) -
        (e - g) * ((b - y) * (c - x) - (a - x) * (d - y))) /
        ((a - c) * (h - f) - (d - b) * (e - g));
    r[1] =
      y -
      ((b - d) * ((e - x) * (h - y) - (f - y) * (g - x)) -
        (f - h) * ((a - x) * (d - y) - (b - y) * (c - x))) /
        ((b - d) * (g - e) - (c - a) * (f - h));
  }
  LLI(m, x[0], y[0], x[2], y[2], x[1], y[1], x[3], y[3]);
  const xm = m[0];
  const ym = m[1];
  if (d > 0) {
    if (Math.abs((x[0] - x[1]) * (y[3] - y[2]) - (y[0] - y[1]) * (x[3] - x[2])) < ep) {
      f[0] = xm + x[0] - x[1] + x[3] - x[2];
      f[1] = ym + y[0] - y[1] + y[3] - y[2];
    } else LLI(f, x[0], y[0], x[1], y[1], x[3], y[3], x[2], y[2]);
    LLI(m, f[0], f[1], xm, ym, x[1], y[1], x[2], y[2]);
    x1 = m[0];
    y1 = m[1];
    LLI(m, f[0], f[1], xm, ym, x[3], y[3], x[0], y[0]);
    x3 = m[0];
    y3 = m[1];
    if (Math.abs((x[1] - x[2]) * (y[0] - y[3]) - (y[1] - y[2]) * (x[0] - x[3])) < ep) {
      f[0] = xm + x[1] - x[2] + x[0] - x[3];
      f[1] = ym + y[1] - y[2] + y[0] - y[3];
    } else LLI(f, x[1], y[1], x[2], y[2], x[0], y[0], x[3], y[3]);
    LLI(m, f[0], f[1], xm, ym, x[0], y[0], x[1], y[1]);
    x0 = m[0];
    y0 = m[1];
    LLI(m, f[0], f[1], xm, ym, x[3], y[3], x[2], y[2]);
    x2 = m[0];
    y2 = m[1];
    drawPerspective(ctx, img, l, t, r - xc, b - yc, [x[0], x0, xm, x3], [y[0], y0, ym, y3], d - 1, s);
    drawPerspective(ctx, img, l + xc, t, r, b - yc, [x0, x[1], x1, xm], [y0, y[1], y1, ym], d - 1, s);
    drawPerspective(ctx, img, l, t + yc, r - xc, b, [x3, xm, x2, x[3]], [y3, ym, y2, y[3]], d - 1, s);
    drawPerspective(ctx, img, l + xc, t + yc, r, b, [xm, x1, x[2], x2], [ym, y1, y[2], y2], d - 1, s);
    return;
  }
  for (i = 0; i < 4; i++) {
    x0 = x[i] - xm;
    y0 = y[i] - ym;
    x1 = x[(i + 1) % 4] - xm;
    y1 = y[(i + 1) % 4] - ym;
    ctx.save();
    ctx.translate(xm, ym);
    ctx.transform(
      (x1 - x0) / w,
      (y1 - y0) / w,
      ((xc * (x0 - x1)) / w - x0) / yc,
      ((xc * (y0 - y1)) / w - y0) / yc,
      0,
      0
    );
    ctx.beginPath();
    ctx.moveTo(-xc - s, -yc - s);
    ctx.lineTo(0, s);
    ctx.lineTo(w - xc + s, -yc - s);
    ctx.closePath();
    ctx.clip();
    if (i == 1) {
      ctx.translate(w / 2 - xm, h / 2 - ym);
      ctx.transform(0, -1, 1, 0, 0, 0);
      ctx.translate(h / 2 - ym, xm - w / 2);
      ctx.transform(h / w, 0, 0, w / h, 0, 0);
    }
    if (i == 2) {
      ctx.translate(w / 2 - xm, h / 2 - ym);
      ctx.transform(-1, 0, 0, -1, 0, 0);
      ctx.translate(w / 2 - xm, h / 2 - ym);
    }
    if (i == 3) {
      ctx.translate(w / 2 - xm, h / 2 - ym);
      ctx.transform(0, 1, -1, 0, 0, 0);
      ctx.translate(ym - h / 2, w / 2 - xm);
      ctx.transform(h / w, 0, 0, w / h, 0, 0);
    }
    sl = s + Math.min(l - s, 0);
    st = s + Math.min(t - s, 0);
    sr = 2 * s - Math.max(l - sl + w + 2 * s, img.width) + img.width;
    sb = 2 * s - Math.max(t - st + h + 2 * s, img.height) + img.height;
    ctx.drawImage(img, l - sl, t - st, w + sr, h + sb, -xc - sl, -yc - st, w + sr, h + sb);
    ctx.restore();
  }
};
